import { render, staticRenderFns } from "./TeamMemberOverview.vue?vue&type=template&id=5a32d984&scoped=true"
import script from "./TeamMemberOverview.vue?vue&type=script&lang=ts"
export * from "./TeamMemberOverview.vue?vue&type=script&lang=ts"
import style0 from "./TeamMemberOverview.vue?vue&type=style&index=0&id=5a32d984&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32d984",
  null
  
)

export default component.exports